export function initGa(trackingId) {
  return new Promise((resolve) => {
    if (!document.getElementById('GA4Script')) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || []
        const f = d.getElementsByTagName(s)[0]
        const j = d.createElement(s)
        j.async = true
        j.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`
        j.id = 'GA4Script'
        j.onload = function () {
          resolve()
        }
        f.parentNode.insertBefore(j, f)
      })(window, document, 'script', 'dataLayer', trackingId)
    }
    else 
      resolve()
  })
}

export function gaStartEvent() {
  if ('gtag' in window === false) {
    window.gtag = function () {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments)
    }
  }

  if (window.dataLayer.length === 0 || !window.dataLayer.find((event) => event[0] === 'js'))
    window.gtag('js', new Date())
}
